import React, { useContext } from 'react';
import { Elements } from '@stripe/react-stripe-js';
import { useStripe, useElements, CardElement } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';

import { MyCardRow } from 'components/Elements/MyCard';
import MyButton from 'components/Elements/MyButton';

import AttachMoneyTwoToneIcon from '@material-ui/icons/AttachMoneyTwoTone';

import { NotificationContext } from 'components/NotificationOverlay';

const stripePromise = accountId =>
  loadStripe(
    `${process.env.publish_key}`,
    accountId
      ? {
          stripeAccount: accountId,
        }
      : null
  );

function StripeCardElementWrapper(WrapperComponent) {
  const ElementWrapper = ({ accountId, options, ...otherProps }) => (
    <Elements stripe={stripePromise(accountId)} options={options}>
      <WrapperComponent {...otherProps} />
    </Elements>
  );

  return ElementWrapper;
}

const StripeCardElement = ({ handleUpdateStripePayment }) => {
  const stripe = useStripe();
  const elements = useElements();
  const { showNotification } = useContext(NotificationContext);

  const updateStripePayment = async () => {
    if (!stripe || !elements) {
      return;
    }

    const cardElement = elements.getElement(CardElement);

    const { error, token } = await stripe.createToken(cardElement);

    if (error) {
      showNotification(`Sorry, Failed to update card: ${error.message}`, 'error');
      return;
    }

    if (token) {
      handleUpdateStripePayment(token);
    }
  };

  return (
    <div>
      <CardElement options={{ hidePostalCode: true, disableLink: true }} />
      <hr className="MuiDivider-root mt-3 mb-2" />
      <MyCardRow>
        <MyButton type="primary" onClick={updateStripePayment}>
          <span className="btn-wrapper--icon">
            <AttachMoneyTwoToneIcon fontSize="small" />
          </span>
          <span className="btn-wrapper--label">Update</span>
        </MyButton>
      </MyCardRow>
    </div>
  );
};

export default StripeCardElementWrapper(StripeCardElement);
